<template>
  <div class="header-filters">
    Відобразити структуру підрядників для бюджету
    <div class="input-wrapper budget">
      <input
        class="budget-filter"
        :placeholder="!dropdownControl.budget ? budgetName : '' "
        v-model="budgetSearch"
        @click="dropdownControl.budget = !dropdownControl.budget"
      />
      <div
        class="dropdown-options"
        v-if="dropdownControl.budget"
      >
        <div
          class="option-box"
          v-for="budgetName in contractorsComputed"
          :key="budgetName"
          @click="optionSelector($event, 'budget')"
        >
          {{budgetName}}
        </div>
      </div>
      <!-- <datalist id="budget-name">
        <option
          v-for="budgetName in jsonContractors"
          :key="budgetName"
        >
          {{ budgetName }}
        </option>
      </datalist> -->
      <img
        src="../assets/images/arrow.png"
        class="arrow-icon"
      />
    </div>

    <br />
    за
    <div class="select-wrapper year">
      <input
        class="year-filter"
        v-model="yearChoice"
        readonly="readonly"
        @click="dropdownControl.year = !dropdownControl.year"
      />
      <div
        class="dropdown-options"
        v-if="dropdownControl.year"
      >
        <div
          class="option-box"
          v-for="year in yearFilters"
          type="text"
          :placeholder="yearChoice"
          :key="year"
          @click="optionSelector($event, 'year')"
        >
          {{year}}
        </div>
      </div>
      <!-- <option
          v-for="year in yearFilters"
          :key="year"
          :value="year"
        >
          {{ year }}
        </option> -->
      <img
        src="../assets/images/arrow.png"
        class="arrow-icon"
      />
    </div>

    рік у розрізі

    <div class="select-wrapper quantity">
      <input
        class="quantity-filter"
        v-model="quantityChoice"
        readonly="readonly"
        @click="dropdownControl.quantity = !dropdownControl.quantity"
      />
      <div
        class="dropdown-options"
        v-if="dropdownControl.quantity"
      >
        <div
          class="option-box"
          v-for="filterObj in quantityFilters"
          type="text"
          :placeholder="quantityChoice"
          :key="filterObj.value"
          @click="optionSelector($event, 'quantity')"
        >
          {{filterObj.name }}
        </div>
      </div>
      <!-- <option
          v-for="filterObj in quantityFilters"
          :key="filterObj.value"
          :value="filterObj.name"
        >
          {{ filterObj.name }}
        </option> -->
      <img
        src="../assets/images/arrow.png"
        class="arrow-icon"
      />
    </div>

    підписаних контрактів.
  </div>
</template>

<script>
export default {
  props: ["jsonContractors", "budgetName"],
  data() {
    return {
      // jsonContractors: [],
      // budgetChoice: "",
      quantityFilters: [
        { value: "count", name: "кількості" },
        { value: "sum", name: "суми" },
      ],
      quantityChoice: "суми",
      yearFilters: [2019, 2020],
      yearChoice: 2020,
      budgetSearch: "",
      budgetChoice: "",
      dropdownControl: { budget: false, year: false, quantity: false },
    };
  },
  methods: {
    optionSelector(event, kind) {
      if (kind === "budget") {
        this.budgetChoice = event.target.innerHTML.trim();
      } else if (kind === "year") {
        this.yearChoice = parseInt(event.target.innerHTML.trim());
      } else {
        this.quantityChoice = event.target.innerHTML.trim();
      }
      this.dropdownControl[kind] = false;
    },
    // sendFilterProps() {
    //   this.$emit("sendFiltersProps", {
    //     quantity: this.quantityChoice,
    //     year: this.yearChoice,
    //   });
    // },
  },
  // mounted() {
  //   this.jsonContractors = require("@/assets/data/sample_contractors_data.json");
  // },
  computed: {
    contractorsComputed() {
      if (this.budgetSearch) {
        let filtered = this.jsonContractors.filter((contractor) =>
          contractor
            .toLowerCase()
            .includes(this.budgetSearch.toLowerCase().trim())
        );

        return filtered;
      } else {
        return this.jsonContractors;
      }
    },
    // contractorsList() {
    //   let list = [];
    //   this.jsonContractors.forEach((row) => {
    //     let budgetName = row["budgetName"];
    //     if (!list.includes(budgetName)) {
    //       list.push(budgetName);
    //     }
    //   });
    //   return list;
    // },
  },
  watch: {
    budgetChoice() {
      if (this.budgetChoice !== "") {
        this.$emit("sendBudgetName", this.budgetChoice);
      }
    },
    quantityChoice() {
      this.$emit("sendFiltersProps", {
        quantity: this.quantityChoice,
        year: this.yearChoice,
      });
    },
    yearChoice() {
      this.$emit("sendFiltersProps", {
        quantity: this.quantityChoice,
        year: this.yearChoice,
      });
    },
  },
};
</script>

<style lang="scss">
.header-filters {
  // margin: 48px 0 48px 16px;
  margin: 48px 0 48px 0;
  line-height: 1.8em;
  input,
  select {
    color: #6e7dbd;
  }

  .input-wrapper {
    display: inline-block;
    position: relative;
    input {
      width: 432px;
      padding: 0 24px 0 8px;
      // color: transparent;
      text-shadow: 0 0 0 #6e7dbd;
      box-sizing: border-box;
      box-shadow: none;
      border: 1px solid black;
      outline: none;
      // cursor: default;
      &::placeholder {
        // padding-left: 4px;
        // color: #a3add6;
        color: #6e7dbd;
      }
      &::-moz-placeholder {
        opacity: 1;
      }
      &::-webkit-calendar-picker-indicator {
        display: none;
      }
    }
  }
  .select-wrapper {
    display: inline-block;
    position: relative;
    input {
      font-family: e-UkraineLight;
      padding: 0 24px 0 4px;
      box-sizing: border-box;
      box-shadow: none;
      border: 1px solid black;
      -moz-appearance: none;
      -webkit-appearance: none;
      outline: none;
      color: transparent;
      text-shadow: 0 0 0 #6e7dbd;
      cursor: default;
      &::ms-expand {
        display: none;
      }
    }
    &.year {
      .year-filter {
        width: 96px;
      }
      .dropdown-options {
        width: 96px;
        height: auto;
      }
    }

    &.quantity {
      .quantity-filter {
        width: 160px;
      }
      .dropdown-options {
        width: 160px;
        height: auto;
      }
    }
    .dropdown-options {
      overflow-y: auto;
    }
  }
  .dropdown-options {
    position: absolute;
    z-index: 1;
    background-color: white;
    padding: 8px 16px;
    // top: 0;
    box-shadow: 0px 3px 5px rgb(0 0 0 / 20%);
    font-size: 14px;
    width: 432px;
    height: 432px;
    overflow-y: scroll;
    box-sizing: border-box;
    .option-box {
      cursor: pointer;
      &:hover {
        color: #6e7dbd;
      }
    }
  }
  img.arrow-icon {
    pointer-events: none;
    position: absolute;
    object-fit: contain;
    top: 35%;
    right: 8px;
    width: 12px;
    height: 12px;
  }
}
@media (max-width: 480px) {
  .header-filters {
    .input-wrapper {
      input {
        text-overflow: ellipsis;
        width: 100%;
      }
    }
  }
}
</style>